import $ from 'jquery';

class Rack {
    constructor() {
        this.orderForm = $('.gf-rack');

        if (!this.orderForm.length) return;

        this.orderFiled = $('.gf-rack__order input');

        this.events();
    }

    events() {
        gform.addAction('gform_input_change', this.createOrder.bind(this));
    }

    setGAPrice() {
        const totalPrice = +$('.gf-rack__total-price input').val().replace(' ', '');
        const $gaTotalPriceField = $('.gf-rack__ga-total-price input');
        $gaTotalPriceField.val(totalPrice);
    }

    calcPriceRUB() {

        const isCurrencyRUB = $('.gf-rack__currency input').is(':checked');

        let currency = isCurrencyRUB ? 'руб.' : 'евро';

        if (ATLEX_OBJ.lang === 'ru' && isCurrencyRUB) {
            currency = 'руб.';
        } else if (ATLEX_OBJ.lang === 'ru' && !isCurrencyRUB) {
            currency = 'евро';
        }

        if (ATLEX_OBJ.lang === 'en' && isCurrencyRUB) {
            currency = 'rubles';
        } else if (ATLEX_OBJ.lang === 'en' && !isCurrencyRUB) {
            currency = 'euro';
        }

        const power = $('.gf-rack__prop-power').find('option');
        const lane = $('.gf-rack__prop-lane').find('option');

        // Все цены
        power.filter((id, item) => {
            let price = +item.value;
            const label = item.textContent.split('—');

            if (isCurrencyRUB) {
                price = Math.round((price - 120) * ATLEX_OBJ.exchange_rate.eur);
            }

            const value = `${price.toLocaleString('ru-RU')} ${currency}`;

            item.textContent = `${label[0]} — ${value}`;
        });

        lane.filter((id, item) => {
            let price = +item.value;
            const label = item.textContent.split('—');

            if (isCurrencyRUB) {
                price = Math.round(price * ATLEX_OBJ.exchange_rate.eur);
            }

            const value = `${price.toLocaleString('ru-RU')} ${currency}`;

            item.textContent = `${label[0]} — ${value}`;
        })
    }

    calcInputPriceRUB(attr) {

        const isEuFrom = $('.gf-rack').hasClass('gf-rack--eu');

        const totalPriceFiled = $(`.gf-rack__${attr}`);
        const totalPriceInput = totalPriceFiled.find('input');
        const totalPriceText = totalPriceFiled.find('.gfield_description');

        const isCurrencyRUB = $('.gf-rack__currency input').is(':checked');
        let currency = 'руб.';

        if (ATLEX_OBJ.lang === 'ru' && (isCurrencyRUB || !isEuFrom)) {
            currency = 'руб.';
        } else if (ATLEX_OBJ.lang === 'ru' && !isCurrencyRUB) {
            currency = 'евро';
        }

        if (ATLEX_OBJ.lang === 'en' && (isCurrencyRUB || !isEuFrom)) {
            currency = 'rubles';
        } else if (ATLEX_OBJ.lang === 'en' && !isCurrencyRUB) {
            currency = 'euro';
        }

        let price = +totalPriceInput.val().replace(/ ,?|,/g, '');

        if (isEuFrom) {
            if (isCurrencyRUB) {
                price = Math.round(price * ATLEX_OBJ.exchange_rate.eur).toLocaleString('ru-RU');
            } else {
                price = price.toLocaleString('en-GB');
            }
        } else {
            price = price.toLocaleString('ru-RU');
        }

        totalPriceText.text(price + ' ' + currency);

    }

    createOrder(elem, formId, fieldId) {

        this.calcPriceRUB();
        this.calcInputPriceRUB('total-price');
        this.calcInputPriceRUB('base-price');

        this.setGAPrice();

    }

}

export default Rack;
